var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGas01 = function SvgGas01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "gas-01_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gas-01_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.116 13.482c-.023 1.01-.23 1.966-.643 2.816a5.68 5.68 0 0 1-5.118 3.206 6.47 6.47 0 0 1-6.473-6.476A6.46 6.46 0 0 1 8.54 7.8c.09-.05.18-.097.273-.142a5.712 5.712 0 0 0 2.341 4.28 5.715 5.715 0 0 1-.23-3.773c.115-.405.273-.789.47-1.151a5.73 5.73 0 0 1 2.73-2.518v.006a5.685 5.685 0 0 0 1.562 3.926c.191.201.398.39.617.564 0 0 1.88 1.53 1.813 4.49Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gas-01_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgGas01 as ReactComponent };